/**
 * @generated SignedSource<<a9ef9263950d13a905e0178dd42c24b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type annotationCreateAnnotationMutation$variables = {
  annotationCategoryId: string;
  connections: ReadonlyArray<string>;
  dataFileId?: string | null;
  description?: string | null;
  eventTime?: string | null;
  flightId: string;
  flightUtime?: number | null;
  mediaGeojson?: any | null;
  videoUsec?: number | null;
};
export type annotationCreateAnnotationMutation$data = {
  readonly createAnnotation: {
    readonly annotation: {
      readonly annotationCategory: {
        readonly id: string;
        readonly name: string;
        readonly uuid: string;
      } | null;
      readonly description: string | null;
      readonly flightDataFileId: string | null;
      readonly id: string;
      readonly mediaGeojson: any | null;
      readonly uuid: string;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type annotationCreateAnnotationMutation = {
  response: annotationCreateAnnotationMutation$data;
  variables: annotationCreateAnnotationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "annotationCategoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dataFileId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTime"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flightId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flightUtime"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mediaGeojson"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "videoUsec"
},
v9 = [
  {
    "kind": "Variable",
    "name": "annotationCategoryId",
    "variableName": "annotationCategoryId"
  },
  {
    "kind": "Variable",
    "name": "description",
    "variableName": "description"
  },
  {
    "kind": "Variable",
    "name": "eventTime",
    "variableName": "eventTime"
  },
  {
    "kind": "Variable",
    "name": "flightDataFileId",
    "variableName": "dataFileId"
  },
  {
    "kind": "Variable",
    "name": "flightId",
    "variableName": "flightId"
  },
  {
    "kind": "Variable",
    "name": "flightUtime",
    "variableName": "flightUtime"
  },
  {
    "kind": "Variable",
    "name": "mediaGeojson",
    "variableName": "mediaGeojson"
  },
  {
    "kind": "Variable",
    "name": "videoUsec",
    "variableName": "videoUsec"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Annotation",
  "kind": "LinkedField",
  "name": "annotation",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightDataFileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnotationCategory",
      "kind": "LinkedField",
      "name": "annotationCategory",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaGeojson",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "annotationCreateAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CreateAnnotation",
        "kind": "LinkedField",
        "name": "createAnnotation",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "annotationCreateAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CreateAnnotation",
        "kind": "LinkedField",
        "name": "createAnnotation",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "annotation",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "AnnotationEdge"
              }
            ]
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf83e50e39c5bb3f86fa589566c7758f",
    "id": null,
    "metadata": {},
    "name": "annotationCreateAnnotationMutation",
    "operationKind": "mutation",
    "text": "mutation annotationCreateAnnotationMutation(\n  $description: String\n  $dataFileId: String\n  $flightId: String!\n  $annotationCategoryId: String!\n  $flightUtime: Float\n  $eventTime: DateTime\n  $videoUsec: Float\n  $mediaGeojson: GeoJSON\n) {\n  createAnnotation(description: $description, flightId: $flightId, flightDataFileId: $dataFileId, annotationCategoryId: $annotationCategoryId, flightUtime: $flightUtime, eventTime: $eventTime, videoUsec: $videoUsec, mediaGeojson: $mediaGeojson) {\n    annotation {\n      id\n      uuid\n      description\n      flightDataFileId\n      annotationCategory {\n        uuid\n        id\n        name\n      }\n      mediaGeojson\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a3f040b972b2cead5c4179d47a552cc";

export default node;
